import { render } from "./FieldHeader.vue?vue&type=template&id=0d80f178"
import script from "./FieldHeader.vue?vue&type=script&lang=js"
export * from "./FieldHeader.vue?vue&type=script&lang=js"

import "./FieldHeader.vue?vue&type=style&index=0&id=0d80f178&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__